import { render } from "./SpendAndConversionsComparedToCPA.vue?vue&type=template&id=cda9e702&scoped=true"
import script from "./SpendAndConversionsComparedToCPA.vue?vue&type=script&lang=js"
export * from "./SpendAndConversionsComparedToCPA.vue?vue&type=script&lang=js"

import "./SpendAndConversionsComparedToCPA.vue?vue&type=style&index=0&id=cda9e702&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cda9e702"]])

export default __exports__